module.exports = __webpack_public_path__ + "static/calendar-efef3ead5d635d456e5aae029a10660f.svg";